import { css } from 'styled-components';
import { SpacingName } from '../../theme/constants';
import { TypographyName } from '../../theme/typography';
import getSpacing from '../../theme/utils/get-spacing/getSpacing';
import getTypography from '../../theme/utils/get-typography/getTypography';
export const toggle = _ref => {
  let {
    theme,
    $visibleFrom
  } = _ref;
  return css(["", ""], $visibleFrom && `${theme.breakpoints.up($visibleFrom)} {
    display: none;
  }`);
};
export const label = _ref2 => {
  let {
    theme
  } = _ref2;
  return css(["", ";", ";color:", ";display:block;text-decoration:underline;width:100%;"], getTypography(theme, TypographyName.BODY), getSpacing.padding(theme, [SpacingName.SMALL, SpacingName.ZERO, SpacingName.ZERO]), theme.palettes.brand.primary);
};
export const content = _ref3 => {
  let {
    theme,
    $open,
    $visibleFrom
  } = _ref3;
  return css(["display:none;", " ", ""], $open && `
    display: block;
  `, $visibleFrom && `${theme.breakpoints.up($visibleFrom)} {
    display: block;
  }`);
};
//# sourceMappingURL=ExpandableContent.style.js.map